module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fNg8c"))).then(() => parcelRequire('37nVf'));